import React, { useEffect, useState } from "react";
import { auth, database } from "../../Config/firebase"; // Ruta correcta si el archivo se llama firebase.js
import { ref, onValue } from "firebase/database"; // Usamos onValue para escuchar en tiempo real
import VIPBanner from "./VIPBanner";

export default function  FreePay() {
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = auth.currentUser; // Obtiene el usuario autenticado

    if (currentUser) {
      const userRef = ref(database, "usuarios/" + currentUser.uid); // Crea una referencia al nodo 'usuarios'

      // Escuchamos los cambios en tiempo real usando onValue
      const unsubscribe = onValue(userRef, (snapshot) => {
        if (snapshot.exists()) {
          const userData = snapshot.val(); // Obtiene los datos del usuario
          if (userData && userData.typeU === "Cuenta Vip") {
            setUserType("vip"); // Si es Cuenta Vip, no mostrar mensaje
          } else {
            setUserType("normal"); // Si no es Cuenta Vip, muestra el mensaje
          }
        }
        setLoading(false);
      });

      // Limpiar el listener cuando el componente se desmonte
      return () => unsubscribe();
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (userType === "vip") {
    return null; // Si el usuario tiene tipo "Cuenta Vip", no se muestra el mensaje
  }

  return (
    <div className="mb-6 max-w-md mx-auto">
      <VIPBanner />
    </div>
  );
}
